var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoutFilled = function SvgLogoutFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M11 19.392V7.503c0-.69-.355-1.331-.94-1.696l-4-2.5C4.728 2.475 3 3.432 3 5.003v11.888c0 .69.355 1.331.94 1.696l4 2.5c1.332.833 3.06-.125 3.06-1.695Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 11h6m0 0-2 2m2-2-2-2m-8 10.392V7.503m0 11.889c0 1.57-1.728 2.528-3.06 1.695l-4-2.5A1.998 1.998 0 0 1 3 16.891V5.003c0-1.571 1.728-2.528 3.06-1.696l4 2.5c.585.365.94 1.006.94 1.696m0 11.889V19m0-11.497V19m0 0h4a2 2 0 0 0 2-2v-1m0-10V5a2 2 0 0 0-2-2H5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutFilled);
export default ForwardRef;